export const ANALYTICS_EVENTS = {
  APP_LAUNCH: "app_launch",
  SCREEN_VIEW: "screen_view",
  NAVIGATION_CLICK: "navigation_click",
  MENU_TOGGLE: "menu_toggle",
  CITY_CHANGED: "city_changed",
  TOURNAMENT_CHANGED: "tournament_changed",
  BANNER_INTERACTION: "banner_interaction",

  AUTH_CODE_REQUEST: "auth_code_request",
  AUTH_CODE_SUCCESS: "auth_code_success",
  AUTH_CODE_FAILURE: "auth_code_failure",
  AUTH_LOGIN_REQUEST: "auth_login_request",
  AUTH_LOGIN_SUCCESS: "auth_login_success",
  AUTH_LOGIN_FAILURE: "auth_login_failure",
  AUTH_SIGNUP_REQUEST: "auth_signup_request",
  AUTH_SIGNUP_SUCCESS: "auth_signup_success",
  AUTH_SIGNUP_FAILURE: "auth_signup_failure",
  AUTH_LOGOUT: "auth_logout",
  ONBOARDING_STEP_VIEW: "onboarding_step_view",
  ONBOARDING_COMPLETED: "onboarding_completed",

  SCHEDULE_VIEW_MODE_CHANGED: "schedule_view_mode_changed",
  SCHEDULE_PERIOD_CHANGED: "schedule_period_changed",
  SCHEDULE_FILTER_OPENED: "schedule_filter_opened",
  SCHEDULE_FILTER_APPLIED: "schedule_filter_applied",
  SCHEDULE_FILTER_RESET: "schedule_filter_reset",
  SCHEDULE_DATE_NAVIGATION: "schedule_date_navigation",
  SCHEDULE_MATCH_OPENED: "schedule_match_opened",
  SCHEDULE_PDF_DOWNLOAD: "schedule_pdf_download",
  SCHEDULE_VIDEO_OPENED: "schedule_video_opened",
  DATE_PICKER_SELECTION: "date_picker_selection",

  SEARCH_PERFORMED: "search_performed",
  FILTER_PANEL_OPENED: "filter_panel_opened",

  API_RESPONSE: "api_response",
  ERROR_REPORTED: "error_reported",
  CRASH: "crash",
  NETWORK_STATUS: "network_status",
  WEB_VITAL: "web_vital",
} as const;

export type AnalyticsEventName =
  (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS];


